export class DateUtil {

    static toOffsetDateTime(value: string): string {
        if (!value) {
            return value;
        }

        if (value.includes("Z") || value.includes("+") || value.includes("-")) {
            return value;
        }

        const normalized = value.trim().replace(' ', 'T');
        const localDate = new Date(normalized);

        if (Number.isNaN(localDate.getTime())) {
            return value;
        }

        const offsetMinutes = -localDate.getTimezoneOffset();
        const sign = offsetMinutes >= 0 ? '+' : '-';
        const absoluteOffset = Math.abs(offsetMinutes);
        const hours = String(Math.floor(absoluteOffset / 60)).padStart(2, '0');
        const minutes = String(absoluteOffset % 60).padStart(2, '0');

        return `${normalized}:00${sign}${hours}:${minutes}`;
    }
}
